import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";
import { GetAuth } from "../utils/Verbs";
import Grid from "./Grid";
import {  useVsiAppContext } from "../stores/VsiApp";
import {VsiSmallText} from "../styled/App.styled";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";
import "./ClientSwitcher.css";

function ClientSwitcher() {
    const { theme, isTabletScreen, client, switchClient, user, getAccessTokenSilently, isSwitchingClient } = useVsiAppContext();

    const [clientSelectModalOpen, setClientSelectModalOpen] = useState(false);
    const [dropdownClients, setDropdownClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState({});
    const [clientsList, setClientsList] = useState(null);
    const toggle = () => setClientSelectModalOpen(!clientSelectModalOpen);

    useEffect(() => {
        const loadClientsList = async () => {
            try {
                const token = await getAccessTokenSilently();
                const resp = await GetAuth('/api/v6/admin/active_clients', token);
                const data = resp?.data || [];
                setClientsList(data);
            } catch (e) {
                console.error(e);
            }
        }

        if (["super_user", "super_user_read_only"].includes(user.role)) {
            loadClientsList();
        }
    }, [user, getAccessTokenSilently]);

    const onRowClicked = e => {
        setSelectedClient(e.data.clientId);
    }

    const handleSelectClick = async () => {
        await switchClient(selectedClient)
        toggle();
    }
    
    const onRowDoubleClick = async e => {
        await switchClient(e.data.clientId)
        toggle();
    };


    const columnDef = [
        {field: "clientId", headerName: "Client ID", hide: true},
        {field: "name", headerName: "Client Name", sortable: true, resizable: true},
        {
            field: "lastUploadDate",
            width: 125,
            headerName: "Last Upload",
            cellStyle: {textAlign: 'right'},
            sortable: true,
            resizable: true,
        },
        {
            field: "uomPreference",
            width: 125,
            headerName: "UOM Preference",
            cellStyle: {textAlign: 'center'},
            sortable: true,
            resizable: true,
        }
    ];

    useEffect(() => {
        if (clientsList) {
            setDropdownClients(clientsList);
        }
    }, [clientsList]);

    return (
        <div className={"d-flex flex-column align-items-start justify-content-end h-100"}>
            {isTabletScreen ? null : <VsiSmallText className={"mb-1"} $textAlign={"left"}>Change Client:</VsiSmallText>}
            <Button outline onClick={toggle} className={"heart"}>
                <i id="clientSwitcherHeart" className="fa-solid fa-heart heart me-1"></i>
                {isTabletScreen ? null : user ? client.name : "No client loaded"}
            </Button>
            <Modal isOpen={clientSelectModalOpen} className={`bg-${theme}`} style={{ maxHeight: '95vh' }}>
                <ModalHeader className={`bg-${theme} ${theme === 'dark' ? "text-light" : "text-dark"}`}>
                    {isSwitchingClient ? (
                      <span>Making the swap... <Spinner size={"sm"} color={"secondary"}/></span>
                    ) : (
                      clientSelectModalOpen ?
                      'Select one of our amazing clients'
                        : '..Done!'
                    )}
                </ModalHeader>
                <ModalBody className={`bg-${theme} fixGrid`}>
                    <Grid style={{ height: '50vh', maxHeight: '70vh' }}
                        hideColumnControls={true}
                        rowClicked={onRowClicked}
                        data={dropdownClients}
                        isLoading={isSwitchingClient}
                        columnDefs={columnDef}
                        hideRecordCount={true}
                        rowDoubleClicked={onRowDoubleClick}
                        clientSwitcher={true}/>
                </ModalBody>
                <ModalFooter className={`bg-${theme}`}>
                    <Button color="secondary" disabled={isSwitchingClient} onClick={toggle}>
                        Cancel
                    </Button>{' '}
                    <Button color="primary" disabled={isSwitchingClient} onClick={handleSelectClick}>
                        Select
                    </Button>{' '}

                </ModalFooter>
            </Modal>
        </div>
    );
}

export default withErrorBoundary(ClientSwitcher, GeneralErrorBoundary);
